import React from 'react';
import { CtaButton } from '../CtaButton';
import { Reveal } from '../Reveal';
export function InvisiblePain() {
  return <section className="relative w-full overflow-hidden bg-[#1A1A2E] py-20 lg:py-28" data-id="element-123" data-mp="3ob2a3ujvx8rl">
      <div className="pointer-events-none absolute inset-0" aria-hidden="true" data-id="element-124" data-mp="3jdtp7m7cqqmn">
        <div className="absolute -top-40 left-1/3 h-[32rem] w-[32rem] -translate-x-1/2 rounded-full bg-[#1F6E7B]/35 blur-[120px]" data-id="element-125" data-mp="3ee7b7ajp96cs" />
        <div className="absolute -bottom-32 right-0 h-96 w-96 rounded-full bg-[#A9DFE9]/10 blur-[110px]" data-id="element-126" data-mp="fuqp5vsqmcrj" />
        <div className="absolute inset-0 landing-noise opacity-[0.35]" data-id="element-127" data-mp="axh2up0nah7x" />
      </div>

      <div className="relative mx-auto max-w-6xl px-6" data-id="element-128" data-mp="6576aq50yiwo">
        <div className="mx-auto max-w-3xl" data-id="element-129" data-mp="175kvyk4m7i1">
          <Reveal data-id="element-130" data-mp="16clxjresmag">
            <p className="mb-4 text-sm font-bold uppercase tracking-[0.14em] text-[#A9DFE9]" data-id="element-131" data-mp="16vvac2zu2cv">This does not have to be your next year</p>
            <h2 className="text-3xl font-bold leading-tight text-white md:text-4xl" data-id="element-132" data-mp="tw3361oc84as">Why you keep postponing.</h2>
          </Reveal>

          <Reveal delay={0.08} data-id="element-133" data-mp="3nmb28pzjbpmq">
            <div className="mt-8 space-y-6 text-lg leading-relaxed text-white" data-id="element-134" data-mp="3nm1ihk532eph">
              <p data-id="element-135" data-mp="3rmbqf2cfrf6z">
                Missing teeth, loose dentures, or an old dental job that no longer represents you. The cost
                is never just the denture. It is the dinner where you do not order what you want. The family
                photo where you press your lips together. The meeting where you hide your smile with your
                hand. It is that quiet voice every time you look in the mirror:{' '}
                <span className="italic font-semibold text-white" data-id="element-136" data-mp="38u98lno25sv5">&ldquo;At my age there&apos;s nothing left to do&rdquo;</span>{' '}
                or{' '}
                <span className="italic font-semibold text-white" data-id="element-137" data-mp="2zwp1vz7ff4d5">&ldquo;The day I can afford it, I&apos;ll fix it.&rdquo;</span>
              </p>
              <p data-id="element-138" data-mp="t3d7932n5y2m">
                When you finally look for help, you find a market split in two. There are clinics offering
                &ldquo;teeth in a day&rdquo; at prices that look too good to be true, and inflated quotes that never
                explain why they cost what they cost. So you postpone the decision. Another year. Sometimes two.
              </p>
            </div>
          </Reveal>
        </div>

        <div className="mx-auto mt-14 max-w-3xl" data-id="element-139" data-mp="hq4h3sq24skv">
          <Reveal delay={0.06} data-id="element-140" data-mp="hrfmty32caem">
            <p className="border-l-2 border-[#26B3CA] pl-6 text-xl font-semibold text-[#A9DFE9]" data-id="element-141" data-mp="1fdmz7u5lz71j">
              The 5-Day Smile Experience was built specifically to eliminate those doubts. What follows is the exact protocol Pler Smile Dadeland built to do it.
            </p>
            <div className="mt-8" data-id="element-142" data-mp="15lyzl5ywejoz"><CtaButton className="!bg-white !text-[#1A1A2E] hover:!bg-[#A9DFE9]" label="Reserve My Free Consultation" data-id="element-143" data-mp="10oqil8phklpb" /></div>
            <p className="mt-3 text-sm font-medium text-white" data-id="element-144" data-mp="1y4mfm6z1f8j7">The consultation is free and your 10% deposit remains refundable for seven days (refund processing can take up to 60 days).</p>
          </Reveal>
        </div>
      </div>
    </section>;
}